import {Injectable} from '@angular/core';
import {HolidayFilters} from '../interfaces/holiday-filters';
import {BehaviorSubject, Observable} from 'rxjs';
import {HolidayCard} from '../interfaces/holiday-card';
import * as dayjs from 'dayjs';
import {map} from 'rxjs/operators';
import {Pagination} from '../../../../shared/interfaces/pagination';
import {MappingService} from '../../../../shared/services/mapping.service';

@Injectable({
  providedIn: 'root'
})
export class HolidaySearchFilterService {

  updateTrigger: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  pagination: Pagination = {
    pageSize: 5,
    currentPage: 1,
    collectionSize: 0
  };
  filters: HolidayFilters = {
    basis: [],
    departureDate: [],
    nights: [],
    accomodations: [],
    categories: [],
    touroperators: [],
    price: {min: undefined, max: undefined, selectedMin: undefined, selectedMax: undefined},
    customHoliday: {visible: undefined, value: undefined}
  };

  constructor(
    private _mappingService: MappingService
  ) { }

  resetFilters(): void {
    this.filters.basis = [];
    this.filters.departureDate = [];
    this.filters.nights = [];
    this.filters.accomodations = [];
    this.filters.categories = [];
    this.filters.touroperators = [];
    this.filters.price.min = undefined;
    this.filters.price.max = undefined;
    this.filters.price.selectedMin = undefined;
    this.filters.price.selectedMax = undefined;
  }

  formatDate(date: Date): string {
    return dayjs(date).format('DDMMYYYY');
  }

  getFilters(holidays: Observable<HolidayCard[]>): Observable<HolidayFilters> {
    return holidays.pipe(
      map(holidayCards => {
        const nightsPool = [];
        const departureDatePool = [];
        const basisPool = [];
        const accomodationsPool = [];
        const categoriesPool = [];
        const touroperatorsPool = [];
        holidayCards.forEach(holiday => {
          if (holiday.accomodation && holiday.accomodation.category && !categoriesPool.some(e => e.id === holiday.accomodation.category.id)) {
            categoriesPool.push(holiday.accomodation.category);
          }
          if (holiday.accomodation && !accomodationsPool.some(e => e.id === holiday.accomodation.id)) {
            accomodationsPool.push(holiday.accomodation);
          }
          if (!touroperatorsPool.includes(holiday.tourOperator)) {
            touroperatorsPool.push(holiday.tourOperator);
          }
          holiday.solutions.forEach(solution => {
            const price = (solution.hasTotalPrice ? solution.totalPrice : solution.price);
            if (!this.filters.price.min || (this.filters.price.min && price <= this.filters.price.min)) {
              this.filters.price.min = Math.round(parseFloat(String(price)));
            }
            if (!this.filters.price.max || (this.filters.price.max && price >= this.filters.price.max)) {
              this.filters.price.max = Math.round(parseFloat(String(price)));
            }
            if (solution.basis && !basisPool.some(e => e.id === solution.basis.id)) {
              basisPool.push(solution.basis);
            }
            if (!nightsPool.includes(solution.nights)) {
              nightsPool.push(solution.nights);
            }
            if (!departureDatePool.some( e => this.formatDate(e) === this.formatDate(solution.dateFrom))) {
              departureDatePool.push(solution.dateFrom);
            }
          });
        });
        this.filters.customHoliday.visible = !!(holidayCards.find((e) => e.isCustom));
        this.filters.customHoliday.value = false;
        this.filters.accomodations = accomodationsPool.map(e => ({disabled: false, checked: false, element: {id: e.id, value: e}}));
        this.filters.categories = categoriesPool.map(e => ({disabled: false, checked: false, element: {id: e.id, value: e}}));
        this.filters.touroperators = touroperatorsPool.map(e => ({disabled: false, checked: false, element: {id: e, value: e}}));
        this.filters.basis = basisPool.map(e => ({disabled: false, checked: false, element: {id: e.id, value: e.name}}));
        this.filters.departureDate = departureDatePool.map(e => ({disabled: false, checked: false, element: {id: e, value: e}}));
        this.filters.nights = nightsPool.map(e => ({disabled: false, checked: false, element: {id: e, value: e}}));
        return this.filters;
      }));
  }
}
